import cn from "classnames";
import Styles from "./EventTime.module.scss";
import { Text } from "src/components/atoms/Text/Text";
import { DATE_FORMAT, formatDate, getBrowserTimezone, getTimezoneAbbreviation } from "src/utils/date-utils";
import * as Event from "src/state/modules/event";

export interface EventTimeProps {
  event: Event.Event;
}

export const EventTime = ({ event }: EventTimeProps) => {
  const displayTimezone = getBrowserTimezone();
  return (
    <div data-testid="event-time" className={Styles.inline}>
      <Text block={false} align={"center"} color={"white"}>
        {formatDate(event?.start ?? "", displayTimezone, DATE_FORMAT.dayAndMonthAndDay) +
          ", " +
          formatDate(event?.start ?? "", displayTimezone, DATE_FORMAT.time) +
          " - " +
          formatDate(event?.end ?? "", displayTimezone, DATE_FORMAT.time) +
          " " +
          getTimezoneAbbreviation(displayTimezone)}
      </Text>
    </div>
  );
};
